import styled from 'styled-components';

const TagStyle = styled.div`
	--padTB: var(--sp2x);
	--padLR: var(--sp4x);
	--fontSize: var(--header_open);
	--borderRadius: var(--sp7x);

	transition-delay: ${({ $index }) => ($index ? `${$index / 15}s !important` : '0s !important')};

	.tag-wrapper {
		background-color: ${({ $white }) => ($white ? 'var(--white1000)' : 'var(--gray100)')};
		border-radius: var(--borderRadius);
		padding: var(--padTB) var(--padLR);
		font-size: var(--fontSize);

		transition: all var(--trTime) ease-out;
	}

	&.active {
		.tag-wrapper {
			background-color: var(--red1000);
			color: var(--white1000);
		}
	}

	&.large-version {
		--padTB: var(--sp2-5x);
		--padLR: var(--sp5x);
		--fontSize: var(--p1);
		--borderRadius: var(--sp9x);
	}

	&.extra-version {
		--padTB: var(--sp2x);
		--padLR: var(--sp6x);
		--borderRadius: var(--sp9x);

		&.active {
			.tag-wrapper {
				font-weight: 600 !important;
			}
		}
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			&.hover-version {
				&:not(&.active):hover {
					.tag-wrapper {
						background-color: var(--red1000);
						color: var(--white1000);
					}
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--padTB: var(--sp1x);
		--padLR: var(--sp2-5x);

		&.large-version {
			--padTB: var(--sp2x);
			--padLR: var(--sp3x);
		}

		&.extra-version {
			--padTB: var(--sp2x);
			--padLR: var(--sp5x);
		}
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--padTB: var(--sp1x);
		--padLR: var(--sp2-5x);

		&.large-version {
			--padTB: var(--sp2x);
			--padLR: var(--sp3x);
		}

		&.extra-version {
			--padTB: var(--sp2x);
			--padLR: var(--sp5x);
		}
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--padTB: var(--sp1x);
		--padLR: var(--sp2-5x);

		&.large-version {
			--padTB: var(--sp2x);
			--padLR: var(--sp3x);
		}

		&.extra-version {
			--padTB: var(--sp1-5x);
			--padLR: var(--sp4x);
		}
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--padTB: var(--sp1x);
		--padLR: var(--sp2-5x);

		&.large-version {
			--padTB: var(--sp2x);
			--padLR: var(--sp3x);
		}

		&.extra-version {
			--padTB: var(--sp1-5x);
			--padLR: var(--sp4x);
		}
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--padTB: var(--sp0-5x);
		--padLR: var(--sp2x);

		&.large-version {
			--padTB: var(--sp2x);
			--padLR: var(--sp3x);
		}

		&.extra-version {
			--padTB: var(--sp1x);
			--padLR: var(--sp4x);
		}
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--padTB: var(--sp0-5x);
		--padLR: var(--sp2x);

		&.large-version {
			--padTB: var(--sp2x);
			--padLR: var(--sp3x);
		}

		&.extra-version {
			--padTB: var(--sp1x);
			--padLR: var(--sp4x);
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--padTB: var(--sp0-5x);
		--padLR: var(--sp2x);

		&.large-version {
			--padTB: var(--sp2x);
			--padLR: var(--sp3x);
		}

		&.extra-version {
			--padTB: var(--sp1x);
			--padLR: var(--sp4x);
		}
	}
`;

export default TagStyle;
